export const translation = {
  "nav.home": "Startseite",
  "nav.spreadsheet": "Tabelle",
  "nav.guides": "Leitfäden",
  "nav.shipping": "Versand",
  "nav.qc": "Qualitätskontrolle",
  "nav.reviews": "Bewertungen",
  "nav.comparisons": "Vergleiche",
  "nav.safety": "Sicherheit",
  "nav.categories": "Kategorien",
  "nav.language": "Sprache",
  "nav.about": "Über Uns",
  "nav.contact": "Kontakt",
  "nav.buyingGuide": "Kaufratgeber",
  "nav.faq": "FAQ",
  "hero.title": "AllChinaBuy Spreadsheet — Ihr Kompletter Leitfaden für Produkte, Verkäufer, Qualitätskontrolle & Versand",
  "hero.subtitle": "Finden Sie Bessere Produkte mit dem AllChinaBuy Spreadsheet",
  "hero.description": "Das AllChinaBuy Spreadsheet ist ein praktischer Ausgangspunkt zum Entdecken von Produkten, Recherchieren von Verkäufern und Verstehen des Kaufprozesses. Erkunden Sie Produktlisten, Verkäuferinformationen, Qualitätskontroll-Ressourcen, Versand-Leitfäden und nützliche Tipps in einer organisierten Ressource.",
  "hero.cta.primary": "Das AllChinaBuy Spreadsheet Erkunden",
  "hero.cta.secondary": "Den Kompletten Leitfaden Durchsuchen",
  "hero.trust": "Unabhängige Ressource • Aktualisierte Leitfäden • Praktische Kaufinformationen",
  "cta.mainWebsite": "AllChinaBuy Spreadsheet",
  "cta.buyNow": "Jetzt Kaufen",
  "cta.visitMain": "Hauptseite Besuchen",
  "section.whatIs.title": "Was ist das AllChinaBuy Spreadsheet?",
  "section.whatIs.description": "Suchen Sie nach einer einfacheren Möglichkeit, Produkte und Verkäufer zu recherchieren? Das AllChinaBuy Spreadsheet bündelt nützliche Produktinformationen in einer durchsuchbaren Ressource. Anstatt zwischen verstreuten Links zu springen, verwenden Sie die Tabelle, um Kategorien zu entdecken, Optionen zu vergleichen und Ihre Recherche mit detaillierten Leitfäden fortzusetzen.",
  "section.whatIs.cta": "Tabellenressourcen Erkunden",
  "section.everything.title": "Alles, was Sie Über AllChinaBuy Wissen Müssen",
  "card.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "card.spreadsheet.desc": "Entdecken Sie Produkte, Kategorien und Verkäuferressourcen.",
  "card.review.title": "AllChinaBuy Bewertung",
  "card.review.desc": "Verstehen Sie die Plattform, Funktionen, den Kaufprozess und wichtige Überlegungen.",
  "card.shipping.title": "AllChinaBuy Versandkosten",
  "card.shipping.desc": "Lernen Sie Versandmethoden, Preisfaktoren, Lieferzeiten und Möglichkeiten zur Reduzierung unnötiger Kosten kennen.",
  "card.warehouse.title": "AllChinaBuy Lager",
  "card.warehouse.desc": "Verstehen Sie Lagerspeicher, Qualitätskontroll-Fotos, Paketvorbereitung und Versand-Workflow.",
  "card.coupon.title": "AllChinaBuy Gutschein",
  "card.coupon.desc": "Finden Sie aktuelle Gutscheininformationen und verstehen Sie, wie Rabatte funktionieren.",
  "card.discount.title": "AllChinaBuy Rabattcode",
  "card.discount.desc": "Erkunden Sie verfügbare Rabattinformationen und überprüfen Sie die Bedingungen vor der Verwendung eines Codes.",
  "card.legit.title": "AllChinaBuy Seriös",
  "card.legit.desc": "Lernen Sie, wie Sie die Seriosität der Plattform, die Zuverlässigkeit von Verkäufern und häufige Kaufrisiken bewerten.",
  "card.qc.title": "AllChinaBuy Qualitätskontrolle",
  "card.qc.desc": "Verstehen Sie Qualitätskontroll-Fotos, Produktprüfungen und was vor dem Versand zu überprüfen ist.",
  "card.shippingCost.title": "AllChinaBuy Versandkosten",
  "card.shippingCost.desc": "Verstehen Sie Versandtarife, Methoden, Gewichtsfaktoren und wie Sie Kosten schätzen.",
  "card.discountCode.title": "AllChinaBuy Rabattcode",
  "card.discountCode.desc": "Finden Sie aktuelle Rabattcodes und lernen Sie, Angebote vor der Nutzung zu prüfen.",
  "card.sellers.title": "AllChinaBuy Verkäufer",
  "card.sellers.desc": "Lernen Sie, vertrauenswürdige Verkäufer zu erkennen und unzuverlässige Anbieter zu vermeiden.",
  "card.comparison.title": "AllChinaBuy Vergleich",
  "card.comparison.desc": "Vergleichen Sie AllChinaBuy mit anderen Agenten in wichtigen Dimensionen.",
  "card.buyingGuide.title": "AllChinaBuy Kaufratgeber",
  "card.buyingGuide.desc": "Eine Schritt-für-Schritt-Anleitung von der Produktsuche bis zur Lieferung.",
  "card.beginner.title": "AllChinaBuy für Anfänger",
  "card.beginner.desc": "Alles, was Erstkäufer vor ihrer ersten Bestellung wissen müssen.",
  "card.payment.title": "AllChinaBuy Zahlungsleitfaden",
  "card.payment.desc": "Verstehen Sie Zahlungsmethoden, Phasen und bewährte Sicherheitspraktiken.",
  "card.refund.title": "AllChinaBuy Rückerstattungsleitfaden",
  "card.refund.desc": "Erfahren Sie, wie Retouren, Streitigkeiten und Rückerstattungen funktionieren.",
  "card.parcel.title": "AllChinaBuy Paketleitfaden",
  "card.parcel.desc": "Verpackungs-, Konsolidierungs- und Schutz-Tipps für den internationalen Versand.",
  "card.safetyGuide.title": "AllChinaBuy Sicherheitsleitfaden",
  "card.safetyGuide.desc": "Vermeiden Sie Betrug, schützen Sie Ihr Konto und kaufen Sie mit Vertrauen.",
  "section.howTo.title": "Wie Man das AllChinaBuy Spreadsheet Verwendet",
  "step1": "Wählen Sie eine Produktkategorie.",
  "step2": "Öffnen Sie die relevante Tabellenressource.",
  "step3": "Vergleichen Sie Produkte und Verkäufer.",
  "step4": "Überprüfen Sie Qualitätskontrollinformationen und Verkäuferdetails.",
  "step5": "Prüfen Sie Versandinformationen vor der Bestellung.",
  "step6": "Fahren Sie mit der Hauptseite fort, wenn Sie bereit sind.",
  "section.categories.title": "Beliebte AllChinaBuy Spreadsheet Kategorien",
  "category.shoes": "Schuhe",
  "category.hoodies": "Hoodies/Pullover",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jacken",
  "category.pants": "Hosen/Shorts",
  "category.headwear": "Kopfbedeckungen",
  "category.sets": "Sets",
  "category.underwear": "Unterwäsche/Unterhosen",
  "category.jersey": "Trikots",
  "category.accessories": "Accessoires",
  "category.bags": "Taschen",
  "category.belts": "Gürtel",
  "category.perfumes": "Parfums",
  "category.other": "Andere Artikel",
  "section.compare.title": "Vergleichen Sie Vor dem Kauf",
  "section.shipping.title": "AllChinaBuy Versandleitfaden",
  "section.shipping.description": "Versandkosten können je nach Paketgewicht, Ziel, Versandmethode, Abmessungen und aktuellen Spediteurbedingungen variieren. Nutzen Sie unsere Versandressourcen, um die wichtigsten Kostenfaktoren zu verstehen, bevor Sie ein Paket vorbereiten.",
  "section.shipping.cta": "AllChinaBuy Versandkosten-Leitfaden Ansehen",
  "section.safety.title": "AllChinaBuy Sicherheitsleitfaden",
  "section.safety.description": "Der Kauf über internationale Marktplätze erfordert sorgfältige Recherche. Lernen Sie, wie Sie Verkäufer verifizieren, Qualitätskontrollinformationen überprüfen, Kontodaten schützen, Versandrisiken verstehen und verdächtige Angebote erkennen.",
  "section.safety.cta": "AllChinaBuy Sicherheitsleitfaden Lesen",
  "section.guides.title": "Neueste AllChinaBuy Leitfäden",
  "section.faq.title": "Häufig Gestellte Fragen",
  "faq.q1": "Was ist das AllChinaBuy Spreadsheet?",
  "faq.a1": "Das AllChinaBuy Spreadsheet ist eine organisierte Ressource, die Produktinformationen, Verkäuferdetails und Kaufanleitungen zusammenstellt, um Ihnen bei der Produktsuche effizienter zu helfen.",
  "faq.q2": "Wie funktioniert das AllChinaBuy Spreadsheet?",
  "faq.a2": "Die Tabelle kategorisiert Produkte nach Typ, sodass Sie Kategorien durchsuchen, Optionen vergleichen und relevante Verkäufer mit detaillierten Informationen finden können.",
  "faq.q3": "Ist AllChinaBuy seriös?",
  "faq.a3": "AllChinaBuy ist eine Einkaufsagenten-Plattform. Wie bei jedem internationalen Marktplatz ist es wichtig, Verkäufer zu recherchieren, Qualitätskontroll-Fotos zu überprüfen und den Prozess vor dem Kauf zu verstehen.",
  "faq.q4": "Ist AllChinaBuy sicher?",
  "faq.a4": "Sicherheit hängt davon ab, bewährte Praktiken zu befolgen: Verifizieren Sie Verkäufer, überprüfen Sie Qualitätskontroll-Fotos, verwenden Sie sichere Zahlungsmethoden und verstehen Sie Versand- und Rückgaberichtlinien.",
  "faq.q5": "Wie viel kostet der AllChinaBuy Versand?",
  "faq.a5": "Versandkosten variieren je nach Paketgewicht, Abmessungen, Ziel, Versandmethode und aktuellen Spediteurtarifen. Nutzen Sie unseren Versandleitfaden für detaillierte Informationen.",
  "faq.q6": "Wo ist das AllChinaBuy Lager?",
  "faq.a6": "AllChinaBuy betreibt Lager in China für den Empfang, die Inspektion und Weiterleitung von Paketen an internationale Käufer.",
  "faq.q7": "Wie funktionieren AllChinaBuy Gutscheine?",
  "faq.a7": "Gutscheine und Rabattcodes können für neue Benutzer, saisonale Aktionen oder bestimmte Produktkategorien verfügbar sein. Überprüfen Sie immer Bedingungen und Ablaufdaten.",
  "faq.q8": "Wo finde ich einen AllChinaBuy Rabattcode?",
  "faq.a8": "Rabattcodes können über Werbe-E-Mails, Affiliate-Partner oder saisonale Kampagnen verfügbar sein. Überprüfen Sie unseren Gutscheinleitfaden für aktuelle Informationen.",
  "faq.q9": "Wie überprüfe ich Qualitätskontroll-Fotos?",
  "faq.a9": "Qualitätskontroll-Fotos werden im Lager vor dem Versand aufgenommen. Sie können sie in Ihrem Konto überprüfen, um Produktzustand, Farbe und Details zu verifizieren.",
  "faq.q10": "Wie kann ich Produkte über AllChinaBuy finden?",
  "faq.a10": "Verwenden Sie die Tabelle, um Kategorien zu durchsuchen, oder suchen Sie direkt nach Produktname, Kategorie oder Verkäufer, um das Gesuchte zu finden.",
  "finalCta.title": "Bereit, das AllChinaBuy Spreadsheet zu Erkunden?",
  "finalCta.description": "Beginnen Sie mit der Tabelle, vergleichen Sie Ihre Optionen, lernen Sie, wie der Kaufprozess funktioniert, und nutzen Sie unsere Leitfäden für fundiertere Entscheidungen.",
  "finalCta.button": "AllChinaBuy Spreadsheet Erkunden",
  "footer.spreadsheet": "AllChinaBuy Spreadsheet",
  "footer.guides": "Leitfäden",
  "footer.reviews": "Bewertungen",
  "footer.shipping": "Versand",
  "footer.qc": "Qualitätskontrolle",
  "footer.safety": "Sicherheit",
  "footer.about": "Über Uns",
  "footer.contact": "Kontakt",
  "footer.privacy": "Datenschutzrichtlinie",
  "footer.terms": "Nutzungsbedingungen",
  "footer.disclaimer": "Haftungsausschluss",
  "footer.disclaimerText": "Diese Website ist eine unabhängige Informationsressource und nicht mit AllChinaBuy verbunden, es sei denn, dies wird ausdrücklich angegeben.",
  "footer.mainCta": "Hauptseite Besuchen",
  "footer.copyright": "AllChinaBuy Spreadsheet. Alle Rechte vorbehalten.",
  "breadcrumb.home": "Startseite",
  "article.readMore": "Mehr Lesen",
  "article.published": "Veröffentlicht",
  "article.updated": "Aktualisiert",
  "article.author": "Redaktionsteam",
  "article.minRead": "Min. Lesezeit",
  "seo.title.home": "AllChinaBuy Spreadsheet – Produkte, Verkäufer, Qualitätskontrolle & Versandleitfaden",
  "seo.description.home": "Erkunden Sie das AllChinaBuy Spreadsheet mit Produktlisten, vertrauenswürdigen Verkäufern, Qualitätskontroll-Tipps, Versandinformationen, Lagerleitfäden, Bewertungen und praktischen Kaufressourcen.",
  "meta.keywords": "AllChinaBuy, AllChinaBuy Spreadsheet, AllChinaBuy Bewertung, AllChinaBuy Versand, AllChinaBuy Gutschein, AllChinaBuy Rabattcode, AllChinaBuy Lager, AllChinaBuy Qualitätskontrolle, AllChinaBuy seriös, AllChinaBuy Leitfaden",
  "compare.feature": "Funktion",
  "compare.allchinabuy": "AllChinaBuy",
  "compare.superbuy": "Superbuy",
  "compare.cssbuy": "CSSBuy",
  "compare.sugargoo": "Sugargoo",
  "compare.productDiscovery": "Produktentdeckung",
  "compare.spreadsheet": "Tabellenressourcen",
  "compare.qcProcess": "Qualitätskontrollprozess",
  "compare.warehouse": "Lager",
  "compare.shipping": "Versand",
  "compare.payment": "Zahlung",
  "compare.beginnerFriendly": "Anfängerfreundlich",
  "compare.support": "Support",
  "compare.research": "Rechercheerfahrung",
  "learnMore": "Mehr Erfahren",
  "readGuide": "Leitfaden Lesen",
  "backToHome": "← Zurück zur Startseite",
  "safetyCenter.title": "Sicherheitszentrum",
  "safetyCenter.description": "Wichtige Sicherheitsinformationen für Käufe über internationale Marktplätze.",
  "disclaimer.title": "Haftungsausschluss",
  "disclaimer.text": "Diese Website ist eine unabhängige Informationsressource. Alle Informationen werden nur zu Bildungszwecken bereitgestellt. Wir sind nicht mit AllChinaBuy oder einer Einkaufsagenten-Plattform verbunden. Führen Sie vor Käufen immer Ihre eigene Recherche durch.",
  "productShowcase.title": "Ausgewählte Produkte Durchsuchen",
  "productShowcase.description": "Erkunden Sie unsere kuratierte Auswahl in jeder Kategorie. Klicken Sie auf ein Artikel, um den Hauptshop zu besuchen und Ihren Kauf abzuschließen.",
  "productShowcase.ctaTitle": "Möchten Sie mehr sehen?",
  "productShowcase.ctaDesc": "Besuchen Sie den vollständigen Shop für Tausende weitere Produkte in allen Kategorien.",
  "productShowcase.ctaButton": "Vollständigen Shop Besuchen",
  "productShowcase.buyNow": "Jetzt Kaufen"
};